import { useAsyncData } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { getOptionalEndpointTimeoutOptions } from '~/scopes/product/utils/optionalEndpointTimeout'
import { useUrlParams } from '~/scopes/product-core/composables/useUrlParams/useUrlParams'

export function useFetchTechnicalSpecifications() {
  const { productId } = useUrlParams()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    `pp-technical-specifications-${productId}`,
    async () =>
      await $httpFetch('/bm/product/:productId/technical_specifications', {
        pathParams: { productId },
        ...getOptionalEndpointTimeoutOptions(),
      }),
    { lazy: true, dedupe: 'defer' },
  )
}
